import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import TlbsMap from 'tlbs-map-vue';

const app = createApp(App)
app.use(Antd).use(TlbsMap)
app.use(store).use(router).mount('#app')
